module.exports = "/images/car-sharp-regular.svg?710cb405fd2f403838b1afc3b8ad14ae";